export default [
    {
        path: '/settings/financial',
        props: true,
        component: () => import('@/views/Setting/Financial'),
    },
];
